import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form'

export class DeleteCustomersBulkModal extends React.Component {
  constructor(props)  {
    super(props);
  }

  saveChanges = async () => {
    let requestParams = {
      'customers': this.props.customers,
    }
    axios.post('/customers/hide/bulk', requestParams)
          .then(data => {
            this.props.closeModal()
            console.log(data);
            this.props.fetchCustomerData();
            toast.success('Customers removed')
          })
          .catch(err => {
            this.props.closeModal()
            console.log(err); 
            Rollbar.error(err)
            toast.error("Error: Could not remove customers!");
          })
  }

  render() {
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Remove ({this.props.customers.length}) Customers</h5>
            <button type="button" className="close" onClick={this.props.closeModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <p>This will permanently delete all selected customers.</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Cancel</button>
            <button type="button" onClick={this.saveChanges} className="btn btn-primary">Confirm</button>
          </div>
        </div>
      </div>
    );
  }
}